module.exports = __webpack_public_path__ + "img/yellow-rectangle-table-4.1b0dd154.png";